module.exports = __webpack_public_path__ + "media/paliwa/electricity-9dc80ed0.png";